<template>
    <div class="style-wrap section-wrap">
        <div class="left">
            <div class="collapse-title">位置</div>
            <div class="collapse-content">
                <div class="list" v-for="(item, index) in customize_data" @click="change_position(index)" :class="{active: current_position === index}">
                    <div class="item">
                        <img class="magnifier" style="left:60px;bottom:20px;" src="@/assets/images/magnifier.png" @click.stop="mag(item.image)"/>
                        <img class="position-image" :src="item.image" alt="">
                        <p class="position-name">{{item.name}}</p>
                        <span class="btn-customize-cancel" @click.stop="remove_style(index)" >取消</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">

            <div class="big-title">制作方式</div>
            <div class="type-list">
                <div class="type-item" v-for="(item, index) in print_type_list" @click="change_print_type(item.type)" :class="{forbid: allow_tech!= 9 && allow_tech != item.type}">
                    <img class="type-radio" src="@/assets/images/disable-select.png" alt="" v-if="allow_tech!= 9 && allow_tech != item.type"  />
                    <img class="type-radio" src="@/assets/images/select.png" alt="" v-else-if="current_style_data.print_type === item.type" />
                    <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else  />
                    {{item.name}}
                </div>
            </div>

            <div class="big-title">内容类型</div>
            <div class="type-list">
                <div class="type-item" v-for="(item, index) in content_type_list" @click="change_content_type(item.type)" >
                    <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.type === item.type" />
                    <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                    {{item.name}}
                </div>
            </div>

            <div class="customize-area" >
                <template v-if="current_style_data.type===1">
                    <div class="content-wrap">
                        <span class="title">文字内容：</span>
                        <input placeholder="不多于10个英文字母" type="text" :value="current_style_data.text_value" @input="update_text" class="customize-text" />
                    </div>
                    <div class="content-wrap">
                        <span class="title">字体样式：</span>
                        <div class="font-list">
                            <div class="font-item" v-for="(item, index) in current_option.setting.text.font_list" :key="'text-font-' + index" @click="change_font(item.font_name)">
                                <img :src="item.font_image" alt="" class="font-image" />
                                <img class="font-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.text_font===item.font_name" />
                                <img class="font-radio" src="@/assets/images/no-select.png" alt="" v-else />
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">字体颜色：</span>
                        <div class="color-list">
                            <div class="color-item"
                                 v-for="(item, index) in current_option.setting.text.color_list"
                                 :key="'text-color-' + index"
                                 @click="change_color(item)"
                                 v-if="available_text_color_list.length === 0 || available_text_color_list.includes(item.color_key)"
                            >
                                <div class="item-wrap">
                                    <img :src="item.color_image" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.text_color===item.color_key" />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{item.color_name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">高度：</span>
                        <div class="type-list">
                            <div class="type-item" v-for="(item, index) in ['8MM', '10MM', '12MM']" :key="'height-' + index" @click="change_height(item)" >
                                <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.height === item" />
                                <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                {{item}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="current_style_data.type===2">
                    <div class="content-wrap">
                        <input type="file" ref="file" style="display: none" @change="upload">
                        <div class="customize-picture">
                            <img :src="current_style_data.image_value + '?x-oss-process=image/resize,w_100,limit_0'" alt="" class="img-wrap" v-if="current_style_data.image_value" @click="change_picture">
                            <img src="@/assets/images/design/add-rect@2x.png" alt="" class="img-wrap" @click="change_picture" v-else >
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">高度：</span>
                        <div class="type-list">
                            <div class="type-item" v-for="(item, index) in ['20MM', '25MM', '30MM', '35MM', '40MM']" :key="'height-' + index" @click="change_height(item)" >
                                <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.height === item" />
                                <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                {{item}}
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">宽度：</span>
                        <div class="type-list">
                            <div class="type-item" v-for="(item, index) in ['20MM', '25MM', '30MM', '35MM', '40MM', '45MM', '50MM']" :key="'wight-' + index" @click="change_width(item)" >
                                <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.width === item" />
                                <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                {{item}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="current_style_data.type===3">
                    <div class="content-wrap">
                        <span class="title">分类：</span>
                        <div class="type-list">
                            <div class="type-item" v-for="(item, index) in category_list" :key="'cc-' + index" @click="change_category(item)" >

                                <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.category_id === item.id" />
                                <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                {{item.category_name}}
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">图片：</span>
                        <div class="pic-list">
                            <div class="pic-item" v-for="(item, index) in pictures" :key="'ppp-' + index" @click="change_pictures(item.image)">
                                <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(item.image)"/>
                                <img :src="item.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" alt="" class="pic-image" />
                                <img class="pic-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.image_value===item.image" />
                                <img class="pic-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                <p>{{item.name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">颜色：</span>
                        <div class="color-list">
                            <div class="color-item"
                                 v-for="(item, index) in current_option.setting.text.color_list"
                                 :key="'text-color-' + index"
                                 @click="change_color(item)"
                                 v-if="available_text_color_list.length === 0 || available_text_color_list.includes(item.color_key)"
                            >
                                <div class="item-wrap">
                                    <img :src="item.color_image" alt="" class="color-image" />
                                    <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.text_color===item.color_key" />
                                    <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                </div>
                                <p class="color-name">{{item.color_name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-wrap">
                        <span class="title">高度：</span>
                        <div class="type-list">
                            <div class="type-item" v-for="(item, index) in ['20MM', '25MM']" :key="'height-' + index" @click="change_height(item)" >
                                <img class="type-radio" src="@/assets/images/select.png" alt="" v-if="current_style_data.height === item" />
                                <img class="type-radio" src="@/assets/images/no-select.png" alt="" v-else />
                                {{item}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>



        </div>

    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import { uploadFile, MPictureCategory, MPictures } from "@/api"
    const raw_style_data = {
        code: "",
        name: "",
        type: 0,
        text_value: '',
        text_font: '',
        text_color: '',
        text_color_image: '',
        price_yh: 0,
        price_xh: 0,
        print_type: 0,
        category_id: 0,
        image_value: '',
        width: 0,
        height: 0
    }
    export default {
        name: "Custom",
        data() {
            return {
                category_list: [],
                pictures: [],
                current_position: 0,
                current_style_data: { ...raw_style_data },
                content_type_list: [
                    {
                        name: '文字',
                        type: 1,
                    },
                    {
                        name: '传图',
                        type: 2,
                    },
                    {
                        name: '图库',
                        type: 3,
                    }
                ],
                print_type_list: [
                    {
                        name: '压花',
                        type: 1,
                    },
                    {
                        name: '绣花',
                        type: 2,
                    },
                    {
                        name: '刺绣',
                        type: 3,
                    }
                ],
            }
        },
        computed: {
            ...mapState({
                customize_data: (state) => state.mtm.picked_category.customize_data,
                style_data: (state) => state.mtm.form_data.customize_data,
                current_color: (state) => state.mtm.form_data.fabric_list.color,
            }),
            confirm_style_code() {
                return this.style_data.map((item) => item.code)
            },
            current_option() {
                return this.customize_data[this.current_position]
            },
            style_price() {
                let result = 0
                for(let i in this.style_data) {
                    result += parseFloat(this.style_data[i].price_yh) + parseFloat(this.style_data[i].price_xh)
                }

                return result.toFixed(2)
            },
            available_text_color_list() {
                if(!this.current_color.text_color_list) {
                    return []
                }

                return this.current_color.text_color_list.map((item) => item.color_key)
            },
            allow_tech() {
                return this.current_color.tech
            }
        },
        methods: {
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            change_position(index) {
                this.current_position = index
                let object = this.style_data.find((item) => {
                    return item.code === this.customize_data[index].code
                })
                this.current_style_data = object || {...raw_style_data, code: this.customize_data[index].code, name: this.customize_data[index].name}
                this.pictures = this.customize_data[index].setting?.pic?.list || []
            },
            change_print_type(type) {
                if(this.allow_tech != 9 && this.allow_tech != type) {
                    this.$Message.error("该面料不适合此工艺~")
                    return
                }
                this.current_style_data.print_type = type
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.text.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.text.price_xh
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.image.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.image.price_xh
                }
                this.update_customize_data()
            },
            change_content_type(type) {
                this.current_style_data.type = type
                this.current_style_data.image_value = ''
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.text.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 1 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.text.price_xh
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 1) {
                    this.current_style_data.price_yh = this.customize_data[this.current_position].setting.image.price_yh
                    this.current_style_data.price_xh = 0
                }
                if(this.current_style_data.type == 2 && this.current_style_data.print_type == 2) {
                    this.current_style_data.price_yh = 0
                    this.current_style_data.price_xh = this.customize_data[this.current_position].setting.image.price_xh
                }
                this.update_customize_data()
            },
            update_text(e) {
                this.current_style_data.text_value = e.target.value
                this.update_customize_data()
            },
            change_font(font) {
                this.current_style_data.text_font = font
                this.update_customize_data()
            },
            change_color(color) {
                this.current_style_data.text_color = color.color_key
                this.current_style_data.text_color_image = color.color_image
                this.update_customize_data()
            },
            change_category(item) {
                this.current_style_data.category_id = item.id
                let pictures = this.customize_data[this.current_position].setting?.pic?.list || []
                this.pictures = pictures.filter((v) => {
                    return item.id==0 || v.category_id==item.id
                })
            },
            change_width(width) {
                this.current_style_data.width = width
                this.update_customize_data()
            },
            change_height(height) {
                this.current_style_data.height = height
                this.update_customize_data()
            },
            change_pictures(image) {
                this.current_style_data.image_value = image
            },
            change_picture() {
                this.$refs.file.click();
            },
            remove_style(index) {
                let object = this.style_data.find((item) => {
                    return item.code === this.customize_data[index].code
                })
                const current_style_data = object || {...raw_style_data, code: this.customize_data[index].code, name: this.customize_data[index].name}

                this.$store.commit('mtm/remove_customize_data', {code: current_style_data.code})
                if(this.current_style_data.code === current_style_data.code) {
                    this.current_style_data = {...raw_style_data, code: current_style_data.code, name: current_style_data.name, type: 1}
                }
            },
            upload(e) {
                let file = e.target.files[0]
                if(file.size > 10 * 1024 * 1024) {
                    this.$Message.error("文件不能超过10M")
                    return
                }
                if(!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                    this.$Message.error("文件类型只能是jpg,jpeg,png")
                    return
                }
                uploadFile(file, 'mtm_style').then(response => {
                    this.current_style_data.image_value = response.data.url
                    this.update_customize_data()
                }).finally(() => {
                    this.$refs.file.value = ''
                })
            },
            update_customize_data() {
                this.$store.commit('mtm/update_customize_data', {
                    code: this.customize_data[this.current_position].code,
                    data: this.current_style_data
                })
            },
        },
        created() {
            this.change_position(0)
            MPictureCategory().then(response => {
                this.category_list = [{id:0, category_name: '全部'},...response.data]
            })
        }
    }
</script>

<style lang="scss" scoped>
        // chrome,safari浏览器滚动条适配
        ::-webkit-scrollbar {
            width: 10px;
            height: 3px;
        }

        ::-webkit-scrollbar-track {
            background: #eee;
            border-radius: 2px;
        }

        ::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: #ddd
        }

        ::-webkit-scrollbar-corner {
            background: #ddd;
        }

        .section-wrap {
            .left {
                position: absolute;
                top: 0;
                left: 0;
                width: 270px;
                height: 99.5%;
                overflow-y: scroll;

                .collapse-title {
                    width: 100%;
                    height: 44px;
                    line-height: 44px;
                    background: #FAFAFA;
                    text-align: left;
                    font-size: 14px;
                    color: #0F114A;
                    padding: 0 20px;
                    font-weight: bold;
                    user-select: none;
                }

                .collapse-content {
                    .list {
                        padding: 0 20px;

                        .item {
                            position: relative;
                            color: #000;
                            height: 130px;
                            border-bottom: 1px solid #ddd;
                            .position-image {
                                position: absolute;
                                top: 15px;
                                left: 0;
                                width: 100px;
                                height: 100px;
                                border: 1px dashed #ddd;
                            }
                            .position-name {
                                position: absolute;
                                top: 15px;
                                left: 110px;
                                font-size: 15px;
                                color: #333;
                            }
                            .btn-customize-cancel {
                                position: absolute;
                                top: 18px;
                                right: 0;
                                color: red;
                                cursor: pointer;
                            }
                        }
                    }
                    .list.active {
                        .item {

                            .position-image {
                                border: 1px solid #0F114A;
                            }
                            .position-name {
                                font-weight: bold;
                                color: #0F114A;
                            }
                        }
                    }
                }
            }

            .right {
                position: absolute;
                top: 5px;
                right: 0;
                width: 1080px;
                padding: 0 10px;
                height: 98%;
                overflow-y: scroll;

                .big-title {
                    font-size: 15px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 18px;
                    color: #333333;
                    padding-bottom: 10px;
                    margin-top: 32px;
                }

                .type-list {
                    margin: 10px 0;
                    display: flex;
                    .type-item {
                        display: flex;
                        align-items: center;
                        margin-right:60px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 16px;
                        .type-radio {
                            width: 16px;
                            height: 16px;
                            margin-right: 5px;
                        }
                        &.forbid {
                            color: #999;
                        }
                    }
                }

                .customize-area {
                    margin: 5px 0;
                    padding: 10px 10px;
                    border-radius: 2px;
                    .title {
                        width: 70px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 14px;
                        color: #333333;
                    }

                    .content-wrap {
                        margin: 10px 0;

                        .customize-text {
                            margin-left: 10px;
                            width: 220px;
                            height: 36px;
                            padding: 10px;
                            line-height: 36px;
                            border: 1px solid #ddd;
                            border-radius: 2px;
                        }

                        .font-list {
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            .font-item {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                position: relative;
                                width: 100px;
                                text-align: center;
                                margin:10px 8px 0 0;
                                background: white;
                                padding: 2px;
                                cursor: pointer;
                                .font-image {
                                    width: 98px;
                                    height: 42px;
                                    border: 0;
                                    margin: 0;
                                }
                                .font-radio {
                                    position: absolute;
                                    top: 5px;
                                    right: 5px;
                                    width: 13px;
                                    height: 13px;
                                }
                            }
                        }

                        .color-list {
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            .color-item {
                                width: 80px;
                                text-align: center;
                                margin:10px 10px 0 0;
                                cursor: pointer;
                                .item-wrap{
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    position: relative;
                                    .color-image {
                                        width: 80px;
                                        height: 80px;
                                        border: 0;
                                        margin: 0;
                                    }
                                    .color-radio {
                                        position: absolute;
                                        top: 5px;
                                        right: 5px;
                                        width: 13px;
                                        height: 13px;
                                    }
                                }
                                .color-name {
                                    font-size: 14px;
                                }
                            }
                        }

                        .type-list {
                            margin: 10px 0;
                            display: flex;
                            .type-item {
                                display: flex;
                                align-items: center;
                                margin-right:60px;
                                height: 20px;
                                line-height: 20px;
                                font-size: 13px;
                                .type-radio {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 5px;
                                }
                                &.forbid {
                                    color: #999;
                                }
                            }
                        }

                        .customize-picture {
                            width: 275px;
                            margin:0 20px;
                            text-align: center;
                            .img-wrap {
                                cursor: pointer;
                                width: auto;
                                height: 120px;
                            }
                        }

                        .pic-list {
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            .pic-item {
                                position: relative;
                                width: 150px;
                                text-align: center;
                                margin:10px 8px 0 0;
                                background: white;
                                padding: 2px;
                                cursor: pointer;
                                .pic-image {
                                    width:150px;
                                    height:150px;
                                    border: 0;
                                    margin: 0;
                                    object-fit: contain;
                                }
                                .pic-radio {
                                    position: absolute;
                                    top: 5px;
                                    right: 5px;
                                    width: 13px;
                                    height: 13px;
                                }
                            }
                        }
                    }
                }
            }
        }

        .magnifier {
            position: absolute;
            bottom: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            z-index: 10;
        }
        .select-active {
            position: relative;
        }

        .select-active:after {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 20px;
            height: 20px;
            background-image: url("~@/assets/images/design/select@2x.png");
            background-size: 100%;

            content: "";
        }


</style>
